import {Particles} from "../../core/Particles";
import {Callback, Dict} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";
import {ParticlesAngNotes} from "./ParticlesAngNotes";
import {ParticlesAngSleep} from "./ParticlesAngSleep";

const ParticleClasses: Dict<string, new (item: SceneItem, context: AnimationContext, cb: Callback) => Particles> = {
    "ang-notes": ParticlesAngNotes,
    "ang-sleep": ParticlesAngSleep,
};

export class ParticlesAnimation extends Animation {

    private readonly name: string;

    constructor(name: string) {
        super();
        this.name = name;
    }

    public animate(item: SceneItem, context: AnimationContext, cb: Callback) {
        const particleClass = ParticleClasses[this.name];
        if (particleClass) {
            item.delayedCall(this.delay || 0, () => {
                const particles = new particleClass(item, context, () => {
                    this.onComplete();
                    cb();
                });
                if (this.speed) {
                    particles.emitter.frequency /= this.speed;
                }
            });
        } else {
            super.animate(item, context, cb);
        }
    }
}
